// @flow

// #region imports
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'shared/routing/withRouter';
import { QRCodeSVG } from 'qrcode.react';
import { Divider } from '@react-md/divider';
import goldIcon from '../../../assets/ic_goldstart.png';
import platIcon from '../../../assets/ic_partner.png';
import placeHolder from '../../../assets/gallery_place_holder.png';
import storeGroupIcon from '../../../assets/storeIcon.png';
import onlOffGroupIcon from '../../../assets/web_hi_res_512.png';
import { decodeBase64 } from '../../../components/Common/Tool';
import queryString from 'query-string';

// #endregion
class QRCodeScreen extends React.Component {
  constructor(props) {
    super(props);
    const { location } = this.props;
    const url = queryString.parse(location.search);
    const parsed = decodeBase64(url.url);
    this.state = {
      GroupCode: parsed.GroupCode,
      GroupName: parsed.GroupName,
      ImagePath: parsed.ImagePath,
      ProductName: parsed.ProductName,
      SegmentCode: parsed.SegmentCode,
      SupplierName: parsed.SupplierName,
    };
  }
  render() {
    var Icon = null;
    const {
      ImagePath,
      GroupCode,
      GroupName,
      ProductName,
      SegmentCode,
      SupplierName,
    } = this.state;
    if (SegmentCode === 'PLAT') {
      Icon = platIcon;
    } else if (SegmentCode === 'GOLD') {
      Icon = goldIcon;
    } else {
      Icon = null;
    }
    return (
      <div className="card Card-container card-pd-B">
        <div className="row Mb-3 Mb-B10">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <div className="">
              <div className="card-body no-Pd">
                {ImagePath !== '' && ImagePath !== null ? (
                  <img src={ImagePath} className="couponImg" />
                ) : (
                  <img
                    src={placeHolder}
                    style={{ height: 200 }}
                    className="couponImg"
                  />
                )}
              </div>
              <div className="card-Pd">
                <h5 className="card-title">{ProductName}</h5>
                <span className="card-text F5 Mr-R">
                  {Icon !== null ? (
                    <img src={Icon} className="segmentIcon" />
                  ) : null}
                  {SupplierName}
                </span>
                <span className="card-text F5">
                  {GroupCode == 'ONLOFF' ? (
                    <img
                      src={storeGroupIcon}
                      style={{ height: 13 }}
                      className="segmentIcon"
                    />
                  ) : (
                    <img
                      src={onlOffGroupIcon}
                      style={{ height: 13 }}
                      className="segmentIcon"
                    />
                  )}
                  {GroupName}
                </span>
              </div>
              <Divider />
              <div style={{ textAlign: 'center', marginTop: 20 }}>
                <QRCodeSVG
                  value={this.props.qrCode}
                  size={200}
                  style={{ height: 200, width: 200 }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
// #region redux map state and dispatch to props
const mapStateToProps = (state) => {
  return {
    qrCode: state.reward.qrCode,
  };
};
// #endregion
export default compose(connect(mapStateToProps), withRouter)(QRCodeScreen);
